import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import Badge from "./Badge";
import FileTree from "./FileTree";
import {normalizePath, siteTree} from "./siteTree";
import "../../styles/Sidebar.css";

// Nodes from the root down to the one for this route, or null if it isn't in the tree
function chainTo(node, pathname) {
    if (node.to === pathname) return [node];
    for (const child of node.children || []) {
        const rest = chainTo(child, pathname);
        if (rest) return [node, ...rest];
    }
    return null;
}

// e.g. ~/blog/get-to-the-point
function breadcrumb(pathname) {
    const chain = chainTo(siteTree, pathname);
    if (!chain) return "~" + (pathname === "/" ? "" : pathname);
    return "~" + chain.slice(1).map(({name}) => (name.startsWith("/") ? name : "/" + name)).join("");
}

// From the lg breakpoint up the tree is always visible. Below it (stacked layout) the
// tree is hidden behind a button showing the current location, so the page content
// isn't pushed below the fold.
export default function Sidebar() {
    const pathname = normalizePath(useLocation().pathname);
    const [open, setOpen] = useState(false);

    useEffect(() => setOpen(false), [pathname]);

    return (
        <div className="w-100 sidebar">
            <Badge/>
            <button
                type="button"
                className="sb-toggle"
                aria-expanded={open}
                aria-controls="site-tree"
                onClick={() => setOpen((isOpen) => !isOpen)}
            >
                <span className="sb-path">{breadcrumb(pathname)}</span>
                <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown}/>
            </button>
            <div id="site-tree" className={open ? "sb-tree sb-open" : "sb-tree"}>
                <FileTree/>
            </div>
        </div>
    )
}
